import {Injectable} from '@angular/core';
import {Lang} from '../model/lang.model';
import {ApiService} from './api.service';
import {retryAfterMillis} from "../shared/constants";
import {TranslateService} from "@ngx-translate/core";

@Injectable({providedIn: 'root'})
export class LanguageService {

  private languages: Lang[] = [];

  constructor(public apiService: ApiService,
              public translateService: TranslateService) {
    this.load();
  }

  load() {
    this.apiService.get('languages')
      .subscribe(response => {
        let languages: Lang[] = [];
        for (const lang of response) {
          languages.push({
            id: lang.id,
            name: lang.name,
            originalName: lang.originalName
          });
        }
        this.languages = languages;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getLanguages() {
    return this.languages;
  }

  displayLanguage(language: Lang) {
    let display = language.name;
    if (language.name !== language.originalName) {
      display += ' (' + language.originalName + ')';
    }
    return display;
  }
}
